import { Link } from 'component/Link'
import { Divider, Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { DataBanner } from 'page/ProfileScreen/DataBanner/DataBanner'
import { DataDeleteModal } from 'page/ProfileScreen/DataDeleteModal/DataDeleteModal'
import { dataDeleteModal } from 'page/ProfileScreen/DataDeleteModal/DataDeleteModalStore'
import { opt } from 'store/opt'
import { store } from 'store/store'
import { TermFormStore } from 'store/term/term'

export const Powered = observer(() => {
  const custom = opt.powered
  const powered = i18n('PoweredBy')
  const title = custom?.by || store.title
  const link = custom?.url || store.link
  const powered_by = link && !opt.stand ? <Link href={link}>{title}</Link> : title
  const policy = !opt.stand && !opt.boutique
  const size = opt.stand ? 14 : 11
  const semi = opt.stand

  const onData = useLatestCallback(() => {
    store.profile.term = new TermFormStore()
  })

  const onCancel = useLatestCallback(() => {
    store.profile.term = undefined
  })

  return <Space gap={8} center>
    {custom && <Space gap={4}>
      <Typo size={size} semi={semi} tertiary>
        {powered}
      </Typo>
      <Typo size={size} semi={semi}>
        {powered_by}
      </Typo>
    </Space>}
    {custom && policy && <Divider height={8} text tertiary />}
    {policy && <Space onClick={onData}>
      <Typo size={size} dotted>
        {i18n('PrivacySettings')}
      </Typo>
    </Space>}
    {store.profile.term && <DataBanner onCancel={onCancel} />}
    {dataDeleteModal.present && <DataDeleteModal />}
  </Space>
})
